// extracted by mini-css-extract-plugin
module.exports = {"level":"Footer_level__3Y2-Y","levelRight":"Footer_levelRight__2Nc7f"};